export var BookingDurationTypeModel;
(function (BookingDurationTypeModel) {
    BookingDurationTypeModel["FIXED"] = "FIXED";
    BookingDurationTypeModel["VARIABLE"] = "VARIABLE";
})(BookingDurationTypeModel || (BookingDurationTypeModel = {}));
